var map = {
	"./da-dani.json": [
		1079,
		130
	],
	"./da-nd.json": [
		1080,
		131
	],
	"./da-rd.json": [
		1081,
		132
	],
	"./da.json": [
		1082,
		133
	],
	"./en-da.json": [
		1083,
		134
	],
	"./en-dani.json": [
		1084,
		135
	],
	"./en-fi.json": [
		1085,
		136
	],
	"./en-nd.json": [
		1086,
		137
	],
	"./en-no.json": [
		1087,
		138
	],
	"./en-rd.json": [
		1088,
		139
	],
	"./en-sv.json": [
		1089,
		140
	],
	"./en-uk.json": [
		1090,
		141
	],
	"./en.json": [
		1091,
		142
	],
	"./fi.json": [
		1092,
		143
	],
	"./no.json": [
		1093,
		144
	],
	"./sv-fi.json": [
		1094,
		145
	],
	"./sv.json": [
		1095,
		146
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1051;
module.exports = webpackAsyncContext;